import { CurrencyPipe, DecimalPipe, PercentPipe } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { SortEvent } from 'primeng/api';
import { BiDashboardService } from '../bi-dashboard-service/bi-dashboard.service';
import { Filtros } from './../.././../../shared/crud/Filtro/Filtros';
import { ListaBase } from './../.././../../shared/crud/ListaBase';
import { ExportExcelService } from './../.././../../shared/excel-service/export-excel.service';
import { FormatarData } from './../.././../../shared/formatarData';
import { Parametro } from './../.././../../shared/service-base/parametro';
import { ConversaoLibraConverte } from './../../././../../shared/conversao-libra/conversao-libra-converte';

declare var $: any;

@Component({
  selector: 'app-bi-dashboard-lista',
  templateUrl: './bi-dashboard-lista.component.html',
  styleUrls: ['./bi-dashboard-lista.component.css']
})
export class BiDashboardListaComponent extends ListaBase implements OnInit {

  cols: any[];
  _selectedColumns: any[];
  carregando = false;
  InicialData; // Set the first Day of month
  FinalData; // set the last day of query
  parametrosFiltro: any;
  dashboard: any;
  codigo_dealer: any;
  nome_dealer: any;
  registro_servico = 0;
  retencao = 0;
  pecas_budget = 0;
  roupas_budget = 0;
  acessorios_budget = 0;
  spuie = 0;
  spuio = 0;
  cspuio = 0;
  aspuio = 0;
  estoque_amp = 0;
  pca_obsoletos = 0;
  ocultaCodigoDealer: boolean;
  ocultaNomeDealer: boolean;
  ocultaRegistro: boolean;
  ocultaRetencao: boolean;
  ocultaPecasBudget: boolean;
  ocultaRoupasBudget: boolean;
  ocultaAcessoriosBudget: boolean;
  ocultaSpuie: boolean;
  ocultaSpuio: boolean;
  ocultaCspuio: boolean;
  ocultaAspuio: boolean;
  ocultaEstoqueAMP: boolean;
  ocultaPCAObsoletos: boolean;
  ocultaQtdDealer: boolean;
  ocultaPatio: boolean;
  ocultaServico: boolean;
  ocultaNrealizado: boolean;
  ocultaPercent: boolean;
  tempDados: any
  subscription;

  dadosTranslate = {
    "Registro 1º Serviço": "businessIntelligence.dashboard.registroServico",
    "Retenção": "businessIntelligence.dashboard.retencao",
    "Peças Vs Budget": "businessIntelligence.dashboard.pecasBudget",
    "Roupas Vs Budget": "businessIntelligence.dashboard.roupasBudget",
    "Acessórios Vs Budget": "businessIntelligence.dashboard.acessoriosBudget",
    "Estoque AMP": "businessIntelligence.dashboard.estoqueAMP",
    "PCA Obsoletos": "businessIntelligence.dashboard.pcaObsoletos",
    "Brasil": "businessIntelligence.dashboard.brasil"
  }

  constructor(service: BiDashboardService,
    toastr: ToastrService,
    router: Router,
    private exportExcel: ExportExcelService,
    private dashboardService: BiDashboardService,
    private translate: TranslateService,
    private cdRef: ChangeDetectorRef,
    private number: DecimalPipe,
    private percent: PercentPipe,
    private currency: CurrencyPipe,
    private conversaoLibraConverte: ConversaoLibraConverte) {
    super(service, toastr, router);
    this.nomeModulo = 'bi-dashboard'
  }

  ngOnInit() {
    this.buscar();
    this.cols = [
      { field: 'codigo_dealer', header: 'Cod. Dealer', headerBr: 'Cod. Dealer', headerGb: 'Dealer Code',width: '5rem'},
      { field: 'nome_dealer', header: 'Dealer', headerBr: 'Dealer', headerGb: 'Dealer', width: '5rem' },
      { field: 'registro_servico', header: 'businessIntelligence.dashboard.registroServico', headerBr: 'Registro 1º Serviço', headerGb: '1st Service Registration',type: this.percent, arg1: '1.0-0', width: '5rem'  },
      { field: 'retencao', header: 'businessIntelligence.dashboard.retencao', headerBr: 'Retenção', headerGb: 'Retention', type: this.percent, arg1: '1.0-0', width: '5rem'},
      { field: 'pecas_budget', header: 'businessIntelligence.dashboard.pecasBudget', headerBr: 'Peças Vs Budget', headerGb: 'Parts Vs Budget', type: this.currency, arg1: ' ', width: '5rem'},
      { field: 'roupas_budget', header: 'businessIntelligence.dashboard.roupasBudget', headerBr: 'Roupas Vs Budget', headerGb: 'Clothing Vs Budget', type: this.currency, arg1: ' ', width: '5rem'},
      { field: 'acessorios_budget', header: 'businessIntelligence.dashboard.acessoriosBudget', headerBr: 'Acessórios Vs Budget', headerGb: 'Acessories Vs Budget', type: this.currency, arg1: ' ', width: '5rem'},
      { field: 'spuie', header: 'SPUIE', headerBr: 'SPUIE', headerGb: 'SPUIE', type: this.currency, arg1: ' ', width: '5rem'},
      { field: 'spuio', header: 'SPUIO', headerBr: 'SPUIO', headerGb: 'SPUIO', type: this.currency, arg1: ' ', width: '5rem'},
      { field: 'cspuio', header: 'CSPUIO', headerBr: 'CSPUIO', headerGb: 'CSPUIO', type: this.currency, arg1: ' ', width: '5rem'},
      { field: 'aspuio', header: 'ASPUIO', headerBr: 'ASPUIO', headerGb: 'ASPUIO', type: this.currency, arg1: ' ', width: '5rem'},
      { field: 'estoque_amp', header: 'businessIntelligence.dashboard.estoqueAMP', headerBr: 'Estoque AMP', headerGb: 'AMP Invetory', type: this.percent, arg1: '1.0-0', width: '5rem'},
      { field: 'pca_obsoletos', header: 'businessIntelligence.dashboard.pcaObsoletos', headerBr: 'PCA Obsoletos', headerGb: 'Obsolete PCA', type: this.percent, arg1: '1.0-0', width: '5rem'},
    ];

    //conversaolibra
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.buscar();
      });
    //fimConversaolibra
    this._selectedColumns = this.cols;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    //restore original order
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  setaValorData(dataInicial: Date) {
    const dt = new Date();
    if (dataInicial === undefined || dataInicial.toString() === '') {
      const dt = new Date();
      const dataInicial = { 'year': dt.getFullYear(), 'month': dt.getMonth() + 1, 'day': dt.getUTCDate() };
      const dataInicialFormata = new FormatarData(dataInicial.year, dataInicial.month, dataInicial.day, 0, 0, 0).getDataString();
      this.InicialData = dataInicialFormata;
    } else {
      const now = new Date(dataInicial);
      this.InicialData = now.getFullYear() + '-' + ("0" + (now.getMonth() + 1)).slice(-2) + '-' + ("0" + (now.getUTCDate())).slice(-2);
    }

    this.filtros = { data_inicial: this.InicialData };
  }

  carregarFiltrosParametros() {
    if (this.parametrosFiltro) {
      for (const item in this.parametrosFiltro) {
        if (this.parametrosFiltro.hasOwnProperty(item)) {

          this.filtros[item] = this.parametrosFiltro[item];
        }
      }
    }
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.data_inicial;
  }

  carregar() {
    const objFiltro = new Filtros();

    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        objFiltro.filtros.push(new Parametro(chave, this.filtros[chave]));
      }
    }
  }

  exportarExcel() {
    this.exportExcel.nomeModulo = this.nomeModulo;
    this.exportExcel.ExportTOExcel();
  }

  getTranslate(value) {
    return this.dadosTranslate[value];
  }

  buscar() {
    this.carregando = true;

    let objFiltro: Filtros = new Filtros();
    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        super.incluirItemFiltro(chave, objFiltro);
      }
    }

    this.service.buscar(objFiltro).then(res => {

      res.dados.forEach(dados => {
        dados.acessorios_budget = this.conversaoLibraConverte.conversaoLibra(dados.acessorios_budget, null, null);
        dados.aspuio = this.conversaoLibraConverte.conversaoLibra(dados.aspuio, null, null);
        dados.cspuio = this.conversaoLibraConverte.conversaoLibra(dados.cspuio, null, null);
        dados.estoque_amp = this.conversaoLibraConverte.conversaoLibra(dados.estoque_amp, null, null);
        dados.pca_obsoletos = this.conversaoLibraConverte.conversaoLibra(dados.pca_obsoletos, null, null);
        dados.pecas_budget = this.conversaoLibraConverte.conversaoLibra(dados.pecas_budget, null, null);
        dados.registro_servico = this.conversaoLibraConverte.conversaoLibra(dados.registro_servico, null, null);
        dados.retencao = this.conversaoLibraConverte.conversaoLibra(dados.retencao, null, null);
        dados.roupas_budget = this.conversaoLibraConverte.conversaoLibra(dados.roupas_budget, null, null);
        dados.spuie = this.conversaoLibraConverte.conversaoLibra(dados.spuie, null, null);
        dados.spuio = this.conversaoLibraConverte.conversaoLibra(dados.spuio, null, null);
      });

      this.tempDados = res;


      this.calculandoTotal(res);
      this.ocultaFooter();

      this.carregando = false;
    });

  }

  private ocultaFooter(dados: any = this.selectedColumns) {
    this.ocultaCodigoDealer = false;
    this.ocultaNomeDealer = false;
    this.ocultaRegistro = false;
    this.ocultaRetencao = false;
    this.ocultaPecasBudget = false;
    this.ocultaRoupasBudget = false;
    this.ocultaAcessoriosBudget = false;
    this.ocultaSpuie = false;
    this.ocultaSpuio = false;
    this.ocultaCspuio = false;
    this.ocultaAspuio = false;
    this.ocultaEstoqueAMP = false;
    this.ocultaPCAObsoletos = false;

    dados.forEach(header => {
      if (header.field === 'codigo_dealer') {
        this.ocultaCodigoDealer = true;
      } else if (header.field === 'nome_dealer') {
        this.ocultaNomeDealer = true;
      } else if (header.field === 'registro_servico') {
        this.ocultaRegistro = true;
      } else if (header.field === 'retencao') {
        this.ocultaRetencao = true;
      } else if (header.field === 'pecas_budget') {
        this.ocultaPecasBudget = true;
      } else if (header.field === 'roupas_budget') {
        this.ocultaRoupasBudget = true;
      } else if (header.field === 'acessorios_budget') {
        this.ocultaAcessoriosBudget = true;
      } else if (header.field === 'spuie') {
        this.ocultaSpuie = true;
      } else if (header.field === 'spuio') {
        this.ocultaSpuio = true;
      } else if (header.field === 'cspuio') {
        this.ocultaCspuio = true;
      } else if (header.field === 'aspuio') {
        this.ocultaAspuio = true;
      } else if (header.field === 'estoque_amp') {
        this.ocultaEstoqueAMP = true;
      } else if (header.field === 'pca_obsoletos') {
        this.ocultaPCAObsoletos = true;
      }
    });
  }

  calculandoTotal(res) {
    this.registro_servico = 0;
    this.retencao = 0;
    this.pecas_budget = 0;
    this.roupas_budget = 0;
    this.acessorios_budget = 0;
    this.spuie = 0;
    this.spuio = 0;
    this.cspuio = 0;
    this.aspuio = 0;
    this.estoque_amp = 0;
    this.pca_obsoletos = 0;

    for (let dados of res?.dados) {
      this.codigo_dealer = ' ';
      this.nome_dealer = 'Brasil';
      this.registro_servico += dados.registro_servico / res.dados.length;
      this.retencao += dados.retencao / res.dados.length;
      this.pecas_budget += dados.pecas_budget / res.dados.length
      this.roupas_budget += dados.roupas_budget / res.dados.length
      this.acessorios_budget += dados.acessorios_budget / res.dados.length
      this.spuie += dados.spuie / res.dados.length;
      this.spuio += dados.spuio / res.dados.length;
      this.cspuio += dados.cspuio / res.dados.length;
      this.aspuio += dados.aspuio / res.dados.length;
      this.estoque_amp += dados.estoque_amp / res.dados.length;
      this.pca_obsoletos += dados.pca_obsoletos / res.dados.length

    }
  }

  // Ordenação
  customSort(event: SortEvent) {
    event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = null;

      if (value1 == null && value2 != null)
        result = -1;
      else if (value1 != null && value2 == null)
        result = 1;
      else if (value1 == null && value2 == null)
        result = 0;
      else if (typeof value1 === 'string' && typeof value2 === 'string')
        result = value1.localeCompare(value2);
      else
        result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;

      return (event.order * result);
    });
  }

}